import Vue from "vue";
import I18n from "vue-i18n";
import messages from "@/lang";

Vue.use(I18n);

export default new I18n({
  locale: navigator.language.split('-')[0],
  fallbackLocale: "pl" || "de",
  messages,
  silentTranslationWarn: true
});
